"use client"

import type { MouseEvent, ReactNode } from "react"
import { AppLink } from "@/components/navigation/app-link"

type MarketingHashLinkProps = {
  href: string
  className?: string
  children: ReactNode
}

/** In-app link that scrolls to a hash anchor (e.g. /#agents). */
export function MarketingHashLink({ href, className, children }: MarketingHashLinkProps) {
  const [path, hash = ""] = href.split("#")

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (!hash) return

    const targetPath = path || "/"
    const onSamePage = window.location.pathname === targetPath

    if (onSamePage) {
      e.preventDefault()
      const el = document.getElementById(hash)
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" })
        window.history.pushState(null, "", `${targetPath}#${hash}`)
      }
    }
  }

  return (
    <AppLink href={href} className={className} onClick={handleClick}>
      {children}
    </AppLink>
  )
}
